(ns frontend.ui.component.lp-portal.modal.download-modal
  (:require
   [common.util :as cu]
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [frontend.ui.component.modal-dialog.style :as modal-style]
   [frontend.ui.component.layout.style :as layout]
   [frontend.lp-portal.sub :as portal-sub]
   [herb.core :as h]
   [common.localization :as loc]
   [frontend.ui.component.checkbox.view :as checkbox]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]))

(defn select-items
  [state heading items]
  (let [selected-items @state]
    [:div
     {:class (h/<class layout/items-group)}
     [:h2
      {:class (h/<class layout/items-group-heading)}
      heading]
     [:ul
      (->> items
           (map (fn [{:keys [label id]}]
                  ^{:key (str "download-item-" id)}
                  [:li
                   {:class (h/<class layout/list-item)}
                   [checkbox/checkbox
                    {:checked?  (boolean (get selected-items id))
                     :on-change #(swap! state update id not)}
                    label]])))]]))

(defn materials-options
  [materials state]
  [select-items state (loc/tr :lp-report-materials) materials])

(defn exports-options
  "Exports section: PDF / XLS / JSON, each shown only when the contact is allowed
  that format (export-formats), and honoring the tenant source-data override."
  [{:keys [state fund-pdfs holding-reports source-data no-source-data?
           export-formats hide-source-data?]}]
  (let [pdf? (boolean (:pdf export-formats))
        xls? (boolean (:xls export-formats))
        json? (boolean (:json export-formats))
        exports (concat
                 (when pdf?
                   fund-pdfs)
                 (when pdf?
                   holding-reports)
                 (when (and xls?
                            (not no-source-data?)
                            (not hide-source-data?))
                   source-data)
                 (when (and json?
                            (not no-source-data?)
                            (not hide-source-data?))
                   [{:label (loc/tr :fund-data-json)
                     :id    :full-data-set-json}]))]
    (when (seq exports)
      [select-items state (loc/tr :lp-report-exports) (vec exports)])))

(defn view
  [_props]
  (let [state (r/atom {})
        tenant @(rf/subscribe [::portal-sub/tenant])
        tenant-name (:tenant/name tenant)
        hide-source-data? (some #{(cu/str-trim-lcase tenant-name)} ["innovestor" "lifeline ventures"])]
    (fn [{:keys [hide! visible? fund-pdfs holding-reports source-data materials
                 private-materials no-source-data? export-formats download!]}]
      [modal-dialog/modal-dialog
       {:hide!        hide!
        :size         :sm
        :visible?     visible?
        :header-label (loc/tr :select-content-to-download)}
       [:div
        {:class (h/<class layout/row)}
        (when (or (seq materials) (seq private-materials))
          [:div
           {:class (h/<class layout/col-left)}
           (materials-options (concat materials private-materials) state)])
        [:div
         {:class (h/<class layout/col-right)}
         [exports-options
          {:state             state
           :fund-pdfs         fund-pdfs
           :holding-reports   holding-reports
           :source-data       source-data
           :export-formats    export-formats
           :no-source-data?   no-source-data?
           :hide-source-data? hide-source-data?}]]]
       [:<>

        [:div
         {:class (h/<class modal-style/footer-left-container)}
         [button/primary-solid
          {:on-click    #(download! (keys @state))}
          [:span
           {:class (h/<class modal-style/text-uppercase)}
           (loc/tr :download)]]]

        [:div
         {:class (h/<class modal-style/footer-right-container)}
         [button/secondary-hollow
          {:on-click hide!}
          [:span
           {:class (h/<class modal-style/text-uppercase)}
           (loc/tr :cancel)]]]]])))
